import Transition from "./transition";
import FootballTransition from "./football-transition";
import FootballState from "./football-state";
import RecoversPossessionSetting from "./recovers-possession-setting";

const transitions = {
    [FootballTransition.SkipKickoff]: new Transition({
        name: FootballTransition.SkipKickoff,
        displayName: "Forego Kickoff",
        keyStroke: "f"
    }),

    [FootballTransition.AddPlay]: new Transition({
        name: FootballTransition.AddPlay,
        displayName: "Play Entry"
    }),
    [FootballTransition.GameControl]: new Transition({
        name: FootballTransition.GameControl,
        displayName: "Game Control",
        keyStroke: "g",
        icon: "gameControl",
        showInToolbar: true,
        order: {
            [FootballState.AddPlay]: 8
        }
    }),
    [FootballTransition.Rush]: new Transition({
        name: FootballTransition.Rush,
        displayName: "Rush",
        keyStroke: "r",
        icon: "rush",
        order: {
            [FootballState.AddPlay]: 1,
            [FootballState.FumbledSnap]: 1
        }
    }),
    [FootballTransition.KneelDown]: new Transition({
        name: FootballTransition.KneelDown,
        displayName: "Kneel Down",
        keyStroke: "d",
        icon: "rush",
        order: {
            [FootballState.AddPlay]: 7
        }
    }),
    // Fumbled Snap
    [FootballTransition.FumbledSnap]: new Transition({
        name: FootballTransition.FumbledSnap,
        displayName: "Fumbled Snap",
        keyStroke: "f",
        icon: "pass"
    }),
    [FootballTransition.FumbledSnapLost]: new Transition({
        name: FootballTransition.FumbledSnapLost,
        displayName: "Lost",
        keyStroke: "l"
    }),
    [FootballTransition.FumbledSnapRecovered]: new Transition({
        name: FootballTransition.FumbledSnapRecovered,
        displayName: "Recovered",
        keyStroke: "r"
    }),
    // Takes the slot Fumble occupies, so the post-snap tiles read
    // Rush, Pass, Dead Ball, Spike. The two are never offered together.
    [FootballTransition.DeadBall]: new Transition({
        name: FootballTransition.DeadBall,
        displayName: "Dead Ball",
        keyStroke: "d",
        order: {
            [FootballState.FumbledSnap]: 3
        }
    }),
    [FootballTransition.EndOfPlay]: new Transition({
        name: FootballTransition.EndOfPlay,
        displayName: "End of play",
        keyStroke: "e",
        order: {
            [FootballState.PassComplete]: 3,
            [FootballState.Continue]: 3,
            [FootballState.Returned]: 3,
            [FootballState.PassIntercepted]: 3
        }
    }),
    [FootballTransition.NoPenaltyEndOfPlay]: new Transition({
        name: FootballTransition.NoPenaltyEndOfPlay,
        displayName: "Yes",
        keyStroke: "e"
    }),
    [FootballTransition.OutOfBounds]: new Transition({
        name: FootballTransition.OutOfBounds,
        displayName: "Out of bounds",
        keyStroke: "o",
        order: {
            [FootballState.PassComplete]: 2,
            [FootballState.Continue]: 2,
            [FootballState.PassIntercepted]: 2,
            [FootballState.Returned]: 2
        }
    }),
    [FootballTransition.Muffed]: new Transition({
        name: FootballTransition.Muffed,
        displayName: "Muffed",
        keyStroke: "m"
    }),
    [FootballTransition.Fumble]: new Transition({
        name: FootballTransition.Fumble,
        displayName: "Fumble",
        keyStroke: "f",
        order: {
            [FootballState.FumbledSnap]: 3
        }
    }),
    [FootballTransition.FumbleRecovered]: new Transition({
        name: FootballTransition.FumbleRecovered,
        displayName: "Recovered",
        recoversPossession: RecoversPossessionSetting.Yes,
        keyStroke: "r"
    }),
    [FootballTransition.FumbleNotRecovered]: new Transition({
        name: FootballTransition.FumbleNotRecovered,
        displayName: "Lost",
        recoversPossession: RecoversPossessionSetting.No,
        keyStroke: "l"
    }),
    [FootballTransition.Tackle]: new Transition({
        name: FootballTransition.Tackle,
        displayName: "Tackle",
        keyStroke: "t",
        order: {
            [FootballState.PassComplete]: 1,
            [FootballState.Continue]: 1,
            [FootballState.Returned]: 1,
            [FootballState.PassIntercepted]: 1
        }
    }),
    [FootballTransition.PatTry]: new Transition({
        name: FootballTransition.PatTry,
        displayName: "PAT Try",
        keyStroke: "a",
        icon: "patTry",
        order: {
            [FootballState.AddPlay]: 3
        }
    }),
    [FootballTransition.PatKick]: new Transition({
        name: FootballTransition.PatKick,
        displayName: "Kick",
        keyStroke: "k"
    }),
    [FootballTransition.PatReturned]: new Transition({
        name: FootballTransition.PatReturned,
        displayName: "Returned",
        keyStroke: "r"
    }),
    [FootballTransition.PatContinued]: new Transition({
        name: FootballTransition.PatContinued,
        displayName: "Continued",
        keyStroke: "c"
    }),
    [FootballTransition.PatRecovered]: new Transition({
        name: FootballTransition.PatRecovered,
        displayName: "Recovered",
        recoversPossession: RecoversPossessionSetting.Yes,
        keyStroke: "r"
    }),
    [FootballTransition.PatNotRecovered]: new Transition({
        name: FootballTransition.PatNotRecovered,
        displayName: "Lost",
        recoversPossession: RecoversPossessionSetting.No,
        keyStroke: "l"
    }),
    [FootballTransition.PatPointsAwarded]: new Transition({
        name: FootballTransition.PatPointsAwarded,
        displayName: "Points Awarded",
        keyStroke: "a"
    }),
    [FootballTransition.PatPointsNotAwarded]: new Transition({
        name: FootballTransition.PatPointsNotAwarded,
        displayName: "Points Not Awarded",
        keyStroke: "n"
    }),
    [FootballTransition.Finalize]: new Transition({
        name: FootballTransition.Finalize,
        displayName: "Finalize"
    }),
    [FootballTransition.Kick]: new Transition({
        name: FootballTransition.Kick,
        displayName: "Kick",
        icon: "punt",
        keyStroke: "k",
        order: {
            [FootballState.AddPlay]: 5
        }
    }),
    [FootballTransition.CflKick]: new Transition({
        name: FootballTransition.CflKick,
        displayName: "Kick",
        keyStroke: "k",
        order: {
            [FootballState.AddPlay]: 5
        }
    }),
    [FootballTransition.KickOff]: new Transition({
        name: FootballTransition.KickOff,
        displayName: "Kick Off",
        keyStroke: "k"
    }),
    // Deuce (Indoor Football - kickoff through uprights)
    [FootballTransition.Deuce]: new Transition({
        name: FootballTransition.Deuce,
        displayName: "Deuce",
        keyStroke: "dc"
    }),
    [FootballTransition.DeuceGood]: new Transition({
        name: FootballTransition.DeuceGood,
        displayName: "Good",
        keyStroke: "g"
    }),
    [FootballTransition.DeuceMissed]: new Transition({
        name: FootballTransition.DeuceMissed,
        displayName: "Missed",
        keyStroke: "m"
    }),
    // Rebound Net (Indoor Football - ball hits net and stays live)
    [FootballTransition.HitReboundNet]: new Transition({
        name: FootballTransition.HitReboundNet,
        displayName: "Hit Rebound Net",
        keyStroke: "rn"
    }),
    [FootballTransition.ReboundNetCaughtOffense]: new Transition({
        name: FootballTransition.ReboundNetCaughtOffense,
        displayName: "Caught by Offense",
        keyStroke: "o"
    }),
    [FootballTransition.ReboundNetCaughtDefense]: new Transition({
        name: FootballTransition.ReboundNetCaughtDefense,
        displayName: "Intercepted",
        keyStroke: "x"
    }),
    [FootballTransition.ReboundNetHitGround]: new Transition({
        name: FootballTransition.ReboundNetHitGround,
        displayName: "Hit Ground",
        keyStroke: "g"
    }),
    [FootballTransition.ReboundNetFieldedKicking]: new Transition({
        name: FootballTransition.ReboundNetFieldedKicking,
        displayName: "Fielded by Kicking",
        keyStroke: "k"
    }),
    [FootballTransition.ReboundNetFieldedReceiving]: new Transition({
        name: FootballTransition.ReboundNetFieldedReceiving,
        displayName: "Fielded by Receiving",
        keyStroke: "r"
    }),
    // Bar Ball (Indoor Football - kickoff hits goalpost)
    [FootballTransition.HitGoalpost]: new Transition({
        name: FootballTransition.HitGoalpost,
        displayName: "Hit Goalpost (Bar Ball)",
        keyStroke: "bb"
    }),
    [FootballTransition.BarBallRecoveredKicking]: new Transition({
        name: FootballTransition.BarBallRecoveredKicking,
        displayName: "Recovered by Kicking",
        keyStroke: "k"
    }),
    [FootballTransition.BarBallRecoveredReceiving]: new Transition({
        name: FootballTransition.BarBallRecoveredReceiving,
        displayName: "Recovered by Receiving",
        keyStroke: "r"
    }),
    [FootballTransition.NoRecoveryKickReturn]: new Transition({
        name: FootballTransition.NoRecoveryKickReturn,
        displayName: "Returned",
        keyStroke: "r"
    }),
    [FootballTransition.FieldGoal]: new Transition({
        name: FootballTransition.FieldGoal,
        displayName: "Field Goal",
        keyStroke: "f"
    }),
    [FootballTransition.FieldGoalFumble]: new Transition({
        name: FootballTransition.FieldGoalFumble,
        displayName: "Fumble",
        keyStroke: "f"
    }),
    [FootballTransition.FieldGoalFakeRun]: new Transition({
        name: FootballTransition.FieldGoalFakeRun,
        displayName: "Fake Run",
        keyStroke: "fr"
    }),
    [FootballTransition.FieldGoalFakePass]: new Transition({
        name: FootballTransition.FieldGoalFakePass,
        displayName: "Fake Pass",
        keyStroke: "fp"
    }),
    [FootballTransition.FieldGoalGood]: new Transition({
        name: FootballTransition.FieldGoalGood,
        displayName: "Good",
        keyStroke: "g"
    }),
    [FootballTransition.FieldGoalMissed]: new Transition({
        name: FootballTransition.FieldGoalMissed,
        displayName: "Missed",
        keyStroke: "m"
    }),
    [FootballTransition.FieldGoalBlocked]: new Transition({
        name: FootballTransition.FieldGoalBlocked,
        displayName: "Blocked",
        keyStroke: "b"
    }),
    [FootballTransition.KickOffPenalty]: new Transition({
        name: FootballTransition.KickOffPenalty,
        displayName: "Penalty",
        keyStroke: "e"
    }),
    [FootballTransition.KickOffPenaltyAccepted]: new Transition({
        name: FootballTransition.KickOffPenaltyAccepted,
        displayName: "Accepted",
        keyStroke: "a"
    }),
    [FootballTransition.KickOffPenaltyDeclined]: new Transition({
        name: FootballTransition.KickOffPenaltyDeclined,
        displayName: "Declined",
        keyStroke: "d"
    }),
    [FootballTransition.Rouge]: new Transition({
        name: FootballTransition.Rouge,
        displayName: "Rouge",
        keyStroke: "ro"
    }),
    [FootballTransition.Downed]: new Transition({
        name: FootballTransition.Downed,
        displayName: "Downed",
        keyStroke: "d",
        order: {
            [FootballState.Punt]: 2
        }
    }),
    [FootballTransition.TouchBack]: new Transition({
        name: FootballTransition.TouchBack,
        displayName: "Touchback",
        keyStroke: "t",
        order: {
            [FootballState.Punt]: 5
        }
    }),
    [FootballTransition.FairCatch]: new Transition({
        name: FootballTransition.FairCatch,
        displayName: "Fair Catch",
        keyStroke: "c",
        order: {
            [FootballState.Punt]: 4
        }
    }),
    [FootballTransition.KickRecovered]: new Transition({
        name: FootballTransition.KickRecovered,
        displayName: "Recovered",
        recoversPossession: RecoversPossessionSetting.Yes,
        keyStroke: "r"
    }),
    [FootballTransition.KickNotRecovered]: new Transition({
        name: FootballTransition.KickNotRecovered,
        displayName: "Lost",
        recoversPossession: RecoversPossessionSetting.No,
        keyStroke: "l"
    }),
    [FootballTransition.OnSide]: new Transition({
        name: FootballTransition.OnSide,
        displayName: "On Side",
        keyStroke: "o"
    }),
    [FootballTransition.Punt]: new Transition({
        name: FootballTransition.Punt,
        displayName: "Punt",
        keyStroke: "u",
        icon: "punt",
        order: {
            [FootballState.AddPlay]: 4
        }
    }),
    [FootballTransition.PuntBlocked]: new Transition({
        name: FootballTransition.PuntBlocked,
        displayName: "Blocked",
        keyStroke: "b"
    }),
    [FootballTransition.PuntOutOfBounds]: new Transition({
        name: FootballTransition.PuntOutOfBounds,
        displayName: "Out of bounds",
        keyStroke: "o",
        order: {
            [FootballState.Punt]: 3
        }
    }),
    [FootballTransition.FieldGoalOutOfBounds]: new Transition({
        name: FootballTransition.FieldGoalOutOfBounds,
        displayName: "Out of bounds",
        keyStroke: "o"
    }),
    [FootballTransition.Continue]: new Transition({
        name: FootballTransition.Continue,
        displayName: "Continue",
        keyStroke: "c",
        order: {
            [FootballState.PassComplete]: 4
        }
    }),
    [FootballTransition.Returned]: new Transition({
        name: FootballTransition.Returned,
        displayName: "Returned",
        keyStroke: "r",
        order: {
            [FootballState.Punt]: 1
        }
    }),
    //PASS
    [FootballTransition.Pass]: new Transition({
        name: FootballTransition.Pass,
        displayName: "Pass",
        keyStroke: "p",
        icon: "pass",
        order: {
            [FootballState.AddPlay]: 2,
            [FootballState.FumbledSnap]: 2
        }
    }),
    [FootballTransition.PassIntercepted]: new Transition({
        name: FootballTransition.PassIntercepted,
        displayName: "Intercepted (X)",
        keyStroke: "x",
        order: {
            [FootballState.Pass]: 5
        }
    }),
    [FootballTransition.PassComplete]: new Transition({
        name: FootballTransition.PassComplete,
        displayName: "Complete",
        keyStroke: "c",
        order: {
            [FootballState.Pass]: 1
        }
    }),
    [FootballTransition.PassIncomplete]: new Transition({
        name: FootballTransition.PassIncomplete,
        displayName: "Incomplete",
        keyStroke: "i",
        order: {
            [FootballState.Pass]: 2
        }
    }),
    [FootballTransition.PassBrokenUp]: new Transition({
        name: FootballTransition.PassBrokenUp,
        displayName: "Broken Up",
        keyStroke: "b",
        order: {
            [FootballState.Pass]: 4
        }
    }),
    [FootballTransition.PassDropped]: new Transition({
        name: FootballTransition.PassDropped,
        displayName: "Dropped",
        keyStroke: "d",
        order: {
            [FootballState.Pass]: 6
        }
    }),
    [FootballTransition.PassSacked]: new Transition({
        name: FootballTransition.PassSacked,
        displayName: "Sacked",
        keyStroke: "s",
        order: {
            [FootballState.Pass]: 3
        }
    }),
    [FootballTransition.DropKick]: new Transition({
        name: FootballTransition.DropKick,
        displayName: "Drop kick"
    }),
    [FootballTransition.PatBlocked]: new Transition({
        name: FootballTransition.PatBlocked,
        displayName: "Blocked",
        keyStroke: "b"
    }),
    [FootballTransition.PatCompleted]: new Transition({
        name: FootballTransition.PatCompleted,
        displayName: "Good",
        keyStroke: "g",
        order: {
            [FootballState.PatPass]: 1,
            [FootballState.Run]: 2
        }
    }),
    [FootballTransition.PatMissed]: new Transition({
        name: FootballTransition.PatMissed,
        displayName: "Failed",
        keyStroke: "a",
        order: {
            [FootballState.PatPass]: 2,
            [FootballState.Run]: 2
        }
    }),
    [FootballTransition.PatFumbled]: new Transition({
        name: FootballTransition.PatFumbled,
        displayName: "Fumble",
        keyStroke: "f"
    }),
    [FootballTransition.PatPass]: new Transition({
        name: FootballTransition.PatPass,
        displayName: "Pass",
        keyStroke: "p",
        order: {
            [FootballState.PatTry]: 2
        }
    }),
    [FootballTransition.PatIntercepted]: new Transition({
        name: FootballTransition.PatIntercepted,
        displayName: "Intercepted"
    }),
    [FootballTransition.Run]: new Transition({
        name: FootballTransition.Run,
        displayName: "Rush",
        keyStroke: "r",
        order: {
            [FootballState.PatTry]: 1
        }
    }),
    [FootballTransition.Spike]: new Transition({
        name: FootballTransition.Spike,
        displayName: "Spike",
        keyStroke: "s",
        icon: "rush",
        order: {
            [FootballState.AddPlay]: 6,
            [FootballState.FumbledSnap]: 4
        }
    }),
    [FootballTransition.StartDrive]: new Transition({
        name: FootballTransition.StartDrive,
        displayName: "Start Drive",
        keyStroke: "r"
    }),
    [FootballTransition.GameStart]: new Transition({
        name: FootballTransition.GameStart,
        displayName: "Game Start",
        disabled: true
    }),
    [FootballTransition.StartPeriod]: new Transition({
        name: FootballTransition.StartPeriod,
        displayName: "Start Period",
        disabled: true
    }),
    // PENALTIES
    [FootballTransition.Penalty]: new Transition({
        name: FootballTransition.Penalty,
        displayName: "Penalty",
        keyStroke: "e",
        order: {
            [FootballState.AddPlay]: 3
        }
    }),
    [FootballTransition.PenaltyAccepted]: new Transition({
        name: FootballTransition.PenaltyAccepted,
        displayName: "Accepted",
        keyStroke: "a"
    }),
    [FootballTransition.PenaltyDeclined]: new Transition({
        name: FootballTransition.PenaltyDeclined,
        displayName: "Declined",
        keyStroke: "d"
    }),
    [FootballTransition.Offsetting]: new Transition({
        name: FootballTransition.Offsetting,
        displayName: "Offsetting",
        keyStroke: "o"
    }),
    [FootballTransition.StatsCountYes]: new Transition({
        name: FootballTransition.StatsCountYes,
        displayName: "Yes",
        keyStroke: "e"
    }),
    [FootballTransition.SecondOffsetting]: new Transition({
        name: FootballTransition.SecondOffsetting,
        displayName: "Offsetting",
        keyStroke: "o"
    }),
    [FootballTransition.NoPlay]: new Transition({
        name: FootballTransition.NoPlay,
        displayName: "No",
        keyStroke: "n"
    }),
    [FootballTransition.StatsCount]: new Transition({
        name: FootballTransition.StatsCount,
        displayName: "Continue"
    }),
    // Play Penalties
    [FootballTransition.PlayPenalty]: new Transition({
        name: FootballTransition.PlayPenalty,
        displayName: "Penalty",
        keyStroke: "e",
        icon: "penalty",
        showAtBottom: true,
        order: { [FootballState.AddPlay]: 3 }
    }),
    [FootballTransition.PlayPenaltyPenaltyDeclined]: new Transition({
        name: FootballTransition.PlayPenaltyPenaltyDeclined,
        displayName: "Declined",
        keyStroke: "d"
    }),
    [FootballTransition.PlayPenaltyPenaltyAccepted]: new Transition({
        name: FootballTransition.PlayPenaltyPenaltyAccepted,
        displayName: "Accepted",
        keyStroke: "a"
    }),
    [FootballTransition.PlayPenaltyOffsetting]: new Transition({
        name: FootballTransition.PlayPenaltyOffsetting,
        displayName: "Offsetting",
        keyStroke: "o"
    }),
    [FootballTransition.PlayPenaltySecondOffsetting]: new Transition({
        name: FootballTransition.PlayPenaltySecondOffsetting,
        displayName: "Offsetting",
        keyStroke: "o"
    }),
    [FootballTransition.PlayPenaltyStatsCount]: new Transition({
        name: FootballTransition.PlayPenaltyStatsCount,
        displayName: "Continue"
    }),
    [FootballTransition.PlayPenaltyNoPlay]: new Transition({
        name: FootballTransition.PlayPenaltyNoPlay,
        displayName: "No",
        keyStroke: "n"
    }),
    [FootballTransition.Timeout]: new Transition({
        name: FootballTransition.Timeout,
        displayName: "Timeout",
        keyStroke: "to"
    }),
    [FootballTransition.UpdateContext]: new Transition({
        name: FootballTransition.UpdateContext,
        displayName: "Update Field",
        keyStroke: "uf"
    }),
    [FootballTransition.CoinToss]: new Transition({
        name: FootballTransition.CoinToss,
        displayName: "Coin Toss",
        keyStroke: "ct"
    }),
    [FootballTransition.SwapTeams]: new Transition({
        name: FootballTransition.SwapTeams,
        displayName: "Swap Teams",
        keyStroke: "st"
    }),
    [FootballTransition.Lateral]: new Transition({
        name: FootballTransition.Lateral,
        displayName: "Lateral",
        keyStroke: "l"
    }),
    [FootballTransition.Safety]: new Transition({
        name: FootballTransition.Safety,
        displayName: "Safety",
        keyStroke: "sa"
    }),
    [FootballTransition.SetTimeAndPeriod]: new Transition({
        name: FootballTransition.SetTimeAndPeriod,
        displayName: "Time and Period",
        keyStroke: "tp"
    })
};

export default class TransitionBuilder {
    static build(transitionName) {
        return (
            transitions[transitionName] ||
            new Transition({
                name: transitionName,
                displayName: transitionName
            })
        );
    }

    static getByName(transitionName, transitionDefinition) {
        return transitions[transitionName]
            ? Object.assign(transitions[transitionName], transitionDefinition)
            : null;
    }

    static getAll() {
        return Object.keys(transitions).reduce((output, key) => {
            output[key] = TransitionBuilder.build(key);

            return output;
        }, {});
    }
}
